enum ModalHref {
  null,
  'FindTheRightOil',
  'SignIn',
  'Contact',
  'Book',
  'ReadMore'
}

enum OilLabel {
  'GTX' = 'Standard',
  'EDGE' = 'Super premium',
  'MAGNATEC' = 'Premium',
}

enum InforTab {
  null,
  'ShowPackInformation',
  'ShowTests',
  'PackSize'
}

enum PageType {
  ProductPage = 'product page',
  RecommendedOils = 'recommended oils',
  ProductFinder = 'product finder'
}

export {ModalHref, OilLabel, InforTab, PageType};
